import api from './api';

export interface ObjetoSeguro {
  id: number;
  placa: string;
  chassi: string;
  modelo: string;
  marca: string;
  combustivel?: string;
  carroceria?: string;
  qtd_eixos?: number;
  qtd_portas?: number;
  lotacao_oficial: number;
  ano_fabricacao: number;
  ano_modelo: number;
  valor_de_mercado?: number;
  outros?: string;
  apoliceId: number;
}

export interface CreateObjetoSeguroDTO {
  placa: string;
  chassi: string;
  modelo: string;
  marca: string;
  combustivel?: string;
  carroceria?: string;
  qtd_eixos?: number;
  qtd_portas?: number;
  lotacao_oficial: number;
  ano_fabricacao: number;
  ano_modelo: number;
  valor_de_mercado?: number;
  outros?: string;
}

export interface UpdateObjetoSeguroDTO extends Partial<CreateObjetoSeguroDTO> {}

export interface ListagemPaginadaObjetos {
  data: ObjetoSeguro[];
  total: number;
}

export const objetoSeguradoService = {
  listarPorApolice: async (apoliceId: number): Promise<ListagemPaginadaObjetos> => {
    const response = await api.get(`/apolices/${apoliceId}/objeto_seguro`);
    return response.data;
  },

  criar: async (apoliceId: number, dados: any): Promise<ObjetoSeguro> => {
    const response = await api.post(`/apolices/${apoliceId}/objeto_seguro`, dados);
    return response.data;
  },

  atualizar: async (apoliceId: number, objetoId: number, dados: UpdateObjetoSeguroDTO): Promise<ObjetoSeguro> => {
    const response = await api.put(`/objeto_seguro/${objetoId}`, dados);
    return response.data;
  },

  excluir: async (apoliceId: number, objetoId: number): Promise<void> => {
    await api.delete(`/objeto_seguro/${objetoId}`);
  }
}; 